var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-full" },
    [
      _c("router-view"),
      _vm.loadNotification
        ? _c("Notification", {
            attrs: { text: _vm.notificationText, show: _vm.showNotification }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }